import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import { BASE_URL } from 'app/routes'
import { AuthenticationProvider } from './Contexts/AuthenticationProvider'
import { AppRouter } from './AppRouter'

import { ThemeProvider } from 'styled-components'
import { GlobalStyle } from 'src/styles/globalStyle'
import { themeEstra } from 'src/styles/themeEstra'
import { HeaderProvider } from './Contexts/HeaderProvider'
import { Layout } from './components/layout/layout'
import ScrollToTop from './components/shared/ScrollToTop'

export const App: React.FC = () => {
  return (
    <AuthenticationProvider>
      <HeaderProvider>
        <ThemeProvider theme={themeEstra}>
          <GlobalStyle />
          <BrowserRouter basename={BASE_URL}>
            <ScrollToTop />
            <Layout>
              <AppRouter />
            </Layout>
          </BrowserRouter>
        </ThemeProvider>
      </HeaderProvider>
    </AuthenticationProvider>
  )
}
